export default __webpack_public_path__ + "static/media/lock-open-green.a0253d1b.svg";